import React from 'react';
export function ProblemSection() {
  return <section className="py-16 bg-white px-4" data-id="element-231">
      <div className="max-w-3xl mx-auto text-center" data-id="element-232">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-233">
          Aquí es donde entra "CALMA TU MENTE EN 5 MINUTOS"
        </h2>
        <div className="h-1 w-20 bg-[#C4973B] mx-auto rounded-full mb-8" data-id="element-234"></div>

        <p className="text-lg text-gray-600 mb-6" data-id="element-235">
          Este ebook digital fue creado para ayudarte a recuperar tranquilidad
          mental con técnicas prácticas, rápidas y fáciles de aplicar en
          cualquier momento del día.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-236">
          <p className="text-lg font-bold text-[#C06B6B]" data-id="element-237">
            Sin ejercicios eternos.
          </p>
          <p className="text-lg font-bold text-[#C06B6B]" data-id="element-238">
            Sin teorías complicadas.
          </p>
          <p className="text-lg font-bold text-[#C06B6B]" data-id="element-239">
            Sin perder horas intentando relajarte.
          </p>
        </div>

        <p className="mt-6 text-xl font-bold text-gray-900" data-id="element-240">
          Solo herramientas simples que ayudan a reducir ansiedad mental y
          recuperar calma emocional rápidamente.
        </p>
      </div>
    </section>;
}